// Copies each <th> label onto its column's <td data-label> so `table.m-cards` can render as cards on mobile.
function labelTable(table) {
  const heads = [...table.querySelectorAll("thead th")].map((th) => th.textContent.trim());
  table.querySelectorAll("tbody tr").forEach((tr) => {
    let col = 0;
    [...tr.children].forEach((td) => {
      const span = td.colSpan || 1;
      const label = span > 1 ? "" : heads[col] || "";
      if (td.getAttribute("data-label") !== label) td.setAttribute("data-label", label);
      col += span;
    });
  });
}

export function startMobileTableLabels() {
  let queued = false;
  const run = () => { queued = false; document.querySelectorAll("table.m-cards").forEach(labelTable); };
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(run); }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  run();
}
